import ResourceLink from 'components/common/digitalResourcesMaps/resourceLink';
import React, { useCallback } from 'react';
import { IDResource, MapGroupProps } from 'types';
import { getPictureByUrl, onFaviconError } from 'utils/helpers/resourcesMap';

const SocialStudiesLink: React.FC<MapGroupProps> = ({
  resources,
  onHoveredElementChanged,
  onClick,
}) => {
  const onElementHover = useCallback(
    (resource?: IDResource, target?: SVGElement) => {
      if (onHoveredElementChanged) {
        onHoveredElementChanged(resource, target);
      }
    },
    [onHoveredElementChanged]
  );

  const resource1SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <path
        fill="#FFF"
        stroke="#635BDC"
        strokeMiterlimit="10"
        strokeWidth="4"
        d="M559.7 416.8l-34.6 19c-6.5 3.5-14.6 1.2-18.1-5.3l-18.8-34.3c-3.5-6.5-1.2-14.6 5.3-18.1l34.6-19c6.5-3.5 14.6-1.2 18.1 5.3l18.8 34.3c3.5 6.4 1.2 14.5-5.3 18.1z"
      />
      <path
        fill="#41760A"
        d="M556.1 444.4c3.5-8.2-14.4-10.2-23-9.9 2.9 8.7 18 21.7 23 9.9z"
      />
      <path
        fill="#41760A"
        d="M555 444.6c6.6 6.1 14.5-10.1 17.1-18.3-9.2-.2-26.6 9.6-17.1 18.3z"
      />
      <image
        width="54"
        height="54"
        x="500"
        y="371"
        transform="rotate(-28.8 527 398)"
        href={getPictureByUrl(resources[0]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource2SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <path
        fill="#FFF"
        stroke="#635BDC"
        strokeMiterlimit="10"
        strokeWidth="4"
        d="M625.5 466.1l-35.9 3.7c-7.7.8-14.5-4.8-15.3-12.5l-3.6-35.6c-.8-7.7 4.8-14.5 12.5-15.3l35.9-3.7c7.7-.8 14.5 4.8 15.3 12.5l3.6 35.6c.8 7.7-4.8 14.6-12.5 15.3z"
      />
      <image
        width="52"
        height="52"
        x="578.5"
        y="410.5"
        transform="rotate(-5.82 604.5 436.5)"
        href={getPictureByUrl(resources[1]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource3SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <path
        fill="#FFF"
        stroke="#635BDC"
        strokeMiterlimit="10"
        strokeWidth="4"
        d="M680.3 452.7l-32-18.8c-5.4-3.2-7.2-10.1-4-15.5l18.7-31.8c3.2-5.4 10.1-7.2 15.5-4l32 18.8c5.4 3.2 7.2 10.1 4 15.5l-18.7 31.8c-3.1 5.4-10.1 7.2-15.5 4z"
      />
      <path
        fill="#41760A"
        d="M644.6 452.6c7.7-4.5-5.4-16.8-12.5-21.7-3 8.7 1.3 28.2 12.5 21.7z"
      />
      <path
        fill="#41760A"
        d="M639.8 458.3c7.4 5 12.7-12.2 14.1-20.8-9.2 1.2-24.8 13.7-14.1 20.8z"
      />
      <image
        width="50"
        height="50"
        x="654.5"
        y="393"
        transform="rotate(30.67 679.5 418)"
        href={getPictureByUrl(resources[2]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource4SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <path
        fill="#FFF"
        stroke="#635BDC"
        strokeMiterlimit="10"
        strokeWidth="4"
        d="M592.5 540.8l-34.4 11.1c-7.3 2.4-15.2-1.7-17.6-9l-11-34.1c-2.4-7.3 1.7-15.2 9-17.6l34.4-11.1c7.3-2.4 15.2 1.7 17.6 9l11 34.1c2.3 7.4-1.7 15.2-9 17.6z"
      />
      <image
        width="50"
        height="50"
        x="542.5"
        y="503.5"
        transform="rotate(-17.88 527.5 528.5)"
        href={getPictureByUrl(resources[3]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );
  const resource5SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <path
        fill="#FFF"
        stroke="#635BDC"
        strokeMiterlimit="10"
        strokeWidth="4"
        d="M675.1 550.3l-35.4 4.2c-7.2.9-13.8-4.3-14.7-11.6l-4.1-35.1c-.9-7.2 4.3-13.8 11.6-14.7l35.4-4.2c7.2-.9 13.8 4.3 14.7 11.6l4.1 35.1c.8 7.3-4.4 13.8-11.6 14.7z"
      />
      <image
        width="50"
        height="50"
        x="597"
        y="497.5"
        transform="rotate(-6.73 632 249.5)"
        href={getPictureByUrl(resources[4]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
      <path
        fill="#41760A"
        d="M651.1 565.1c7.7-4.5-5.4-16.8-12.5-21.7-2.9 8.7 1.4 28.2 12.5 21.7z"
      />
      <path
        fill="#41760A"
        d="M646.4 570.8c7.4 5 12.7-12.2 14.1-20.8-9.2 1.3-24.9 13.7-14.1 20.8z"
      />
      <path
        fill="#E4F6FB"
        d="M663.2 564.9c-1.5 1.7-4.5 3.1-5.8 2-1.3-1.1-.3-4.3 1.2-6 1.5-1.7 3-1.4 4.3-.3 1.3 1.2 1.9 2.6.3 4.3z"
      />
      <path
        fill="#E4F6FB"
        d="M662.8 571.9c-2.3-.3-5.1-2.1-4.9-3.7s3.4-2.6 5.7-2.3c2.3.3 2.8 1.8 2.6 3.4-.2 1.6-1.1 2.9-3.4 2.6z"
      />
      <path
        fill="#E4F6FB"
        d="M656.4 574.4c-.8-2.2-.6-5.5.9-6.1s3.9 1.8 4.8 3.9c.8 2.2-.2 3.3-1.8 3.9s-3.1.4-3.9-1.7z"
      />
      <path
        fill="#E4F6FB"
        d="M651.9 567.6c2-1.1 5.4-1.2 6.2.2s-1.3 4.1-3.3 5.2c-2 1.1-3.3.2-4.1-1.3-.8-1.5-.8-3 1.2-4.1z"
      />
      <path
        fill="#E4F6FB"
        d="M656 561.7c1.9 1.3 3.6 4.2 2.6 5.6-1 1.4-4.2.7-6.1-.6-1.9-1.3-1.7-2.8-.7-4.2.9-1.4 2.3-2.1 4.2-.8z"
      />
      <circle cx="657.8" cy="567.5" r="2.4" fill="#FEAF26" />
    </g>
  );

  const resource6SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <path
        fill="#FFF"
        stroke="#635BDC"
        strokeMiterlimit="10"
        strokeWidth="4"
        d="M737.3 544.9l-33.4-12.1c-6.5-2.4-9.9-9.6-7.5-16.1l12-33.1c2.4-6.5 9.6-9.9 16.1-7.5l33.4 12.1c6.5 2.4 9.9 9.6 7.5 16.1l-12 33.1c-2.4 6.5-9.6 9.9-16.1 7.5z"
      />
      <path
        fill="#41760A"
        d="M731.3 558.7c7.7-4.5-5.4-16.8-12.5-21.7-2.9 8.7 1.4 28.2 12.5 21.7z"
      />
      <path
        fill="#41760A"
        d="M726.6 564.4c7.4 5 12.7-12.2 14.1-20.8-9.2 1.2-24.9 13.7-14.1 20.8z"
      />
      <image
        width="48"
        height="48"
        x="707"
        y="486.7"
        transform="rotate(19.95 731 511.7)"
        href={getPictureByUrl(resources[5]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  return (
    <g id="group-1" transform="translate(0, -73)">
      <g id="element-1">
        <g id="component-item-1">
          <g id="social_x5F_studies">
            <ellipse cx="633.4" cy="579.7" fill="#55A32A" rx="127" ry="44.5" />
            <path
              fill="#85610A"
              d="M629.3 608.4c1.1-1.5 1.5-3.4 2.7-4.9 1.7-2.2 4.7-2.8 7.5-3.4 2.5-.5 5.1-1 7.6-.6 2.6.3 5.1 1.5 7.8 1.5 7.3 0 25.5-21.1 17.5-27.3-7.7-6-8.3 18.4-13.4 20.7-1.5.7-3.2.6-4.9.6-7.6-.1-15.1.8-22.4 2.7-2.2.6-4.5 1.3-6.2 3-1.5 1.5-2.3 3.7-3.7 5.4-1.4 1.7-4.1 2.7-5.7 1.2 1.4.2 2.2 1.9 1.8 3.3-.4 1.4-1.4 2.4-2.5 3.4 3.3-3.1 9.6-1.7 11.7-5.9 2.6-5.2-4.5-12.3-8.8-13.9-1.3-.5-2.7-.8-3.7-1.9-2.4-2.5.1-6.6-.2-10-.3-4-4.1-6.7-5.9-10.3-2.4-4.8-.9-10.4-.5-15.7.7-9.8-2.6-19.8-9.1-27.2-3.4 4.8-8 11.6-6.2 17.1 1.5 4.5 6.2 7.3 7.7 11.8 1.8 5.4-1.4 12 1.8 16.7 1.3 1.9 3.4 3.1 5.1 4.6 3 2.7 4.7 6.8 4.7 10.8-.1 3.1-1 6.4.8 8.9 1.4 2 4 2.5 6.3 3.3 2.3.8 10 3.7 10.2 6.1zM489.3 530.3c.2 6.5.4 14.5 6.3 17.4 2.2 1.1 4.8 1.1 7.3 1.5 10.5 1.5 19.1 8.9 26.9 16 6 5.4 12 10.7 17.9 16.1 1.7 1.5 3.4 3.1 5.6 3.7 2.2.6 4.9.1 6-1.9-9.2-11.2-24.3-16.3-33.6-27.4-2.3-2.7-4.2-5.8-7-7.9-4.7-3.6-11.3-4.1-16.2-7.6-6-4.3-8.2-12.4-7.8-19.7.1-2.2.4-4.4-.2-6.5-1.2-4.3-6.1-8.4-8.5-3.9-1.5 2.9 3.1 16.3 3.3 20.2z"
            />
            <path
              fill="#41760A"
              d="M725 590c4.8.2 9.4-2.3 13-5.6 7.4-6.9 11.2-17.3 10-27.3.8.2 1.7.2 2.6.1 6.2-.7 11.6-5.9 12.7-12 1-6.1-2.4-12.7-8-15.5-.1-9.1-1.9-19.7-9.9-24.1-2.8-1.5-6.2-2.1-8.8-3.9-2.6-1.8-4.4-4.8-7.2-6.3s-7.5-.3-7.3 2.9c0-3.1-4.6-5-6.8-2.8-11.8-12.7-27.9-21.3-45.1-24.1-.1 2-.2 3.9-.3 5.9-12.4 10.3-18.4 27.5-15.2 43.2-4.3 4.8-.4 19.3 7 25.4-11.9-7.3-26.1-10.8-40-9.6-5 11.7-8.7 24-11.1 36.5 4.1 1.7 8.7 2.2 13.1 1.5-2.9 2.3-2.5 7.2 0 9.9s6.3 3.8 10 4.5c3.4.6 8.1 3.1 6.4 6.1 6.6-1.4 27.1-8.1 29.9-.3 8.1-5.3 13-3.8 21.8-3.1 10 .8 16-2.6 23.3-9.5.9 4.4 5 7.8 9.9 8.1z"
            />
            <path
              fill="#41760A"
              d="M586 557.7c9.5 3.9 19.3 7.9 29.5 7.3 10.2-.6 20.8-7.2 22.8-17.5 1.5 4.7 8.7 3.3 11.6-.7s3.8-9.3 7.4-12.5c5-4.5 12.5-3 19.1-3 6.6 0 14.9-4.5 13.4-11.2 2.4 2.8 4.7 5.6 7.1 8.4 3.7-1.7 7.9-2.2 11.9-1.7 12-32.3 2.5-71.9-22.8-94.7-5.5-4.9-16.5-7.4-17.9 0-2.1-8.3-4.5-17.2-11-22.7-6.4-5.5-18.1-5-21.4 2.9-2.4-6.1-11.6-7.5-15.6-2.5-6.2-8.9-12.7-18-22-23.4-9.3-5.3-22.1-5.7-29.5 2.2-9-9.6-27.6-4.8-31.3 8-6.1-4.4-13.4 3.3-17 9.9-6 11-12.1 22-18.1 33.1-2.5-3-5-5.9-7.5-8.9-22.6 16.8-33.9 48.1-27.6 76 .9 4 2.2 8 4.7 11.1 4.1 5.3 11 7.4 17.5 8.1 13.2 1.4 26.7-2.4 37.5-10.3-5.1-1.2-7.9 5.9-7.8 11.3.1 3.6.5 7.2 1.6 10.5 1.7 4.9 4.8 9.2 9 12.1 10.9 7.7 25.7 4.9 38 9.7 5.5 2.1 14.6 3.4 14.5-2.6 10.6 7.4 23.9 10.6 36.6 9.1"
            />
            <path
              fill="#6C9B23"
              d="M512.6 439.8c-2.8-7.8-8.3-14.7-15.4-19.2-.8 1.7-.9 3.7-.3 5.5-4.8-4-11.3-5.9-17.6-5.3 2.1 2.6 3.9 5.6 5.2 8.7-4.5-.4-9.1.5-13.2 2.4.1 2.2 3.5 3.1 3.6 5.3 0 .9-.6 1.8-1.2 2.5-3.6 4.7-6 10.4-6.9 16.2-.3 1.8-.3 3.7.9 5.1 1.2 1.3 4 .9 4.1-.8.1 7.9.3 15.8.7 23.7 4.5-1 8.5-3.8 11-7.6-.3 3.9 1 7.8 3.6 10.8 2.1-1.4 4.3-2.9 6.4-4.3.3 1.4.5 2.6.8 4 2 1.3 5.1 2.5 6.6.6.4-.5.6-1.2.7-1.8.5-2 .9-3.9 1.4-5.9.5 1.5 1.4 2.9 2.5 4 .2.2.5.5.9.5s.7-.1 1-.3c3.3-2 6.6-4 9.9-5.9 4.7-2.8 10.4-4.2 14.3-8.2-.2 3.3 0 6.6.6 9.8 3.4-3.5 6.8-7.1 10.1-10.6 4.4 1 9.3-1.1 11.6-4.9.5-.8.8-1.6.8-2.5 0-.8-.4-1.6-.8-2.3-1.5-3.1-3-6.2-4.6-9.3l-1.3 1.3c-1.7-1.6-2.8-3.7-3.1-6-.1-.8-.2-1.7-1-2-.6-.2-1.2.1-1.7.4-3.5 2.1-6.9 4.4-10.2 6.9-.4-2.2-1.5-4.5-3.5-5.5s-5-.4-5.8 1.7c-2.3-.8-.7-5.6-3.1-6.1-.6-.1-1.1.1-1.7.1-1.5 0-2.5-1.3-3.5-2.3-.9-1.3-.8.2-1.8 1.3zM534 499.8c-.1-2.1-2.9-3.3-4.7-2.3-1.8 1-2.5 3.4-2 5.4.6 2 2.1 3.6 3.8 4.8 3.3 2.4 7.3 3.6 11.2 4.7 1.3.4 2.7.8 4 .3 1-.3 1.8-1.2 2.8-1.2.7 0 1.4.4 2 .8 8.6 5.4 19.2 7.8 29.3 6.7.8-5 .9-10.2.4-15.3-3.3-.7-7.5.7-9.6-1.9-2.2-2.7.1-6.9-1.1-10.1-2.6 1.8-6-.4-8.8-1.8-4.2-2.2-10.8-3.7-15.6-3.4-8.2.6-8.9 6.7-11.7 13.3zM690.3 559.4c3.1-3 6.2-6 9.2-9.1 1-.9 2-2 2.1-3.3.2-1.6-.9-3-2-4.2-2.7-3.1-5.3-6.1-8-9.2-1.3.6-2.3 1.7-2.9 3.1-.4-4.3-2.1-8.6-5-11.9-1.3.7-2.5 1.5-3.8 2.2-1.7-2.9-3.7-6-6.8-7.3-3.1-1.4-7.6.1-8.1 3.4-2-3.8-6.1-6.8-10.4-6.3s-7.4 6.2-4.7 9.5c-7.9 2.5-12.1 12.9-8 20.2-10-2.2-20.4-2.9-30.6-2-.9.1-1.8.2-2.4.9-.5.6-.5 1.4-.5 2.2v8.5c5.6 2.2 11.8 1.3 17.8 1 5.3-.3 10.6 0 15.9.8-1 5 4.5 9.3 9.6 9.3 5.1-.1 9.7-3 13.9-5.9-1.1 2.4 1.1 5.2 3.7 5.7s5.2-.4 7.6-1.4c7.6-3 15.6-6.4 20.6-12.8M670.9 473.5c2.6 3 7.8 2.8 10.8.2 3.1-2.6 4.3-6.8 4.2-10.8-.8.4-.1 1.9.8 1.8.9-.1 1.6-1 2-1.8 1.4-2.9 2-6.3 1.6-9.5-.1-.8-.3-1.7-.9-2.2-.4-.4-1-.5-1.6-.6-4.5-1-9-1.9-13.5-2.9-.9 1.8-1.3 3.9-1.2 5.9-2.5-1.8-6.6-.1-7.1 2.9-4.7-1.9-9.4-3.7-14.2-5.6-1.7-.7-3.6-1.3-5.2-.6-1.2.5-2 1.7-2.6 2.8-1.8 3.4-2.6 7.4-2.2 11.3-1.3-1.5-3.9-1.7-5.3-.3s-1.4 4 .1 5.3c-5.5 2.3-9.1 8.5-8.4 14.4-1.9 2.1-3.3 4.7-3.8 7.4.8.4 1.7 1.2 2.6 1.4-.8 7.7 8.9.6 12.4.6 4.4-.1 7.5 3.7 11.6 4.3 7.2 1 7.6-4.2 12.2-8.2 2.4-2.1 3.8-.6 5.9-4.2.6-.9 2.4-10.9 1.8-11.6z"
            />
            <path
              fill="#41760A"
              d="M584.8 500.2c6.2-7-11-14.8-19.7-17.4 0 9.6 10.8 27.5 19.7 17.4z"
            />
            <path
              fill="#41760A"
              d="M582 507.4c9.1 2.5 8.6-16.3 7.2-25.2-8.8 4.3-20.3 21.7-7.2 25.2zM620.1 496.9c6.2-7-11-14.8-19.7-17.4 0 9.6 10.8 27.5 19.7 17.4z"
            />
            <path
              fill="#41760A"
              d="M617.3 504.2c9.1 2.5 8.6-16.3 7.2-25.2-8.8 4.2-20.3 21.6-7.2 25.2z"
            />
            <path
              fill="#E4F6FB"
              d="M497.3 430c-2.4 2.8-7.3 5-9.4 3.2-2-1.8-.5-6.9 2-9.6 2.4-2.8 4.8-2.2 6.9-.4 2 1.8 2.9 4.1.5 6.8z"
            />
            <path
              fill="#E4F6FB"
              d="M496.6 441.1c-3.7-.5-8.3-3.3-7.9-6 .4-2.7 5.5-4.2 9.2-3.7 3.7.5 4.5 2.8 4.1 5.5s-1.7 4.7-5.4 4.2z"
            />
            <path
              fill="#E4F6FB"
              d="M486.2 445.1c-1.3-3.4-1-8.8 1.5-9.7 2.5-1 6.3 2.8 7.7 6.2s-.3 5.3-2.9 6.2c-2.5 1-4.9.7-6.3-2.7z"
            />
            <path
              fill="#E4F6FB"
              d="M479 434.3c3.3-1.7 8.7-2 9.9.4 1.2 2.4-2.1 6.6-5.4 8.3-3.3 1.7-5.3.3-6.6-2.1-1.2-2.4-1.2-4.9 2.1-6.6z"
            />
            <path
              fill="#E4F6FB"
              d="M485.6 424.9c3 2.1 5.8 6.7 4.2 8.9-1.6 2.2-6.8 1.2-9.9-.9-3-2.1-2.7-4.6-1.1-6.8s3.8-3.3 6.8-1.2z"
            />
            <ellipse cx="488.5" cy="434.1" fill="#FEAF26" rx="3.9" ry="3.9" />
            <path
              fill="#E4F6FB"
              d="M525.4 458.9c-1.4 1.6-4.2 2.9-5.4 1.9-1.2-1-.3-4 1.1-5.6 1.4-1.6 2.8-1.3 4-.2s1.8 2.3.3 3.9z"
            />
            <path
              fill="#E4F6FB"
              d="M525 465.4c-2.1-.3-4.8-1.9-4.6-3.5.2-1.5 3.2-2.4 5.3-2.1 2.1.3 2.6 1.6 2.4 3.2-.1 1.5-.9 2.7-3.1 2.4z"
            />
            <path
              fill="#E4F6FB"
              d="M519 467.7c-.8-2-.6-5.1.9-5.6 1.5-.6 3.7 1.6 4.5 3.6.8 2-.2 3.1-1.7 3.6s-2.9.4-3.7-1.6z"
            />
            <path
              fill="#E4F6FB"
              d="M514.8 461.4c1.9-1 5-1.2 5.8.2.7 1.4-1.2 3.8-3.1 4.8-1.9 1-3.1.2-3.8-1.2s-.8-2.8 1.1-3.8z"
            />
            <path
              fill="#E4F6FB"
              d="M518.7 456c1.8 1.2 3.4 3.9 2.4 5.2-.9 1.3-4 .7-5.7-.5-1.8-1.2-1.6-2.6-.7-3.9.9-1.4 2.2-2.1 4-.8z"
            />
            <ellipse cx="520.3" cy="461.3" fill="#FEAF26" rx="2.3" ry="2.3" />
            <g>
              <path
                fill="#E4F6FB"
                d="M547.7 488.3c-2.4 2.7-7.2 4.9-9.2 3.2-2-1.7-.5-6.7 1.9-9.4s4.7-2.1 6.7-.4c2.1 1.6 3 3.8.6 6.6z"
              />
              <path
                fill="#E4F6FB"
                d="M547 499.1c-3.6-.5-8.1-3.2-7.7-5.8s5.4-4.1 9-3.6c3.6.5 4.4 2.7 4.1 5.3-.4 2.6-1.8 4.6-5.4 4.1z"
              />
              <path
                fill="#E4F6FB"
                d="M536.9 503c-1.3-3.4-1-8.6 1.5-9.5 2.5-.9 6.2 2.7 7.5 6.1 1.3 3.4-.3 5.2-2.8 6.1s-4.9.6-6.2-2.7z"
              />
              <path
                fill="#E4F6FB"
                d="M529.8 492.4c3.2-1.7 8.5-2 9.7.4 1.2 2.3-2 6.4-5.3 8.1s-5.2.3-6.4-2.1-1.2-4.7 2-6.4z"
              />
              <path
                fill="#E4F6FB"
                d="M536.3 483.3c3 2.1 5.7 6.6 4.1 8.7-1.5 2.2-6.7 1.2-9.7-.9-3-2.1-2.6-4.5-1.1-6.6 1.5-2.2 3.7-3.3 6.7-1.2z"
              />
              <ellipse cx="539.1" cy="492.2" fill="#FEAF26" rx="3.9" ry="3.8" />
            </g>
            <g>
              <path
                fill="#E4F6FB"
                d="M664.8 460.5c-2.4 2.7-7.2 4.9-9.2 3.2-2-1.7-.5-6.7 1.9-9.4s4.7-2.1 6.7-.4c2.1 1.7 3 3.9.6 6.6z"
              />
              <path
                fill="#E4F6FB"
                d="M664.1 471.4c-3.6-.5-8.1-3.2-7.7-5.8s5.4-4.1 9-3.6c3.6.5 4.4 2.7 4.1 5.3-.4 2.6-1.8 4.6-5.4 4.1z"
              />
              <path
                fill="#E4F6FB"
                d="M654 475.3c-1.3-3.4-1-8.6 1.5-9.5s6.2 2.7 7.5 6.1-.3 5.2-2.8 6.1c-2.5.9-4.9.6-6.2-2.7z"
              />
              <path
                fill="#E4F6FB"
                d="M646.9 464.7c3.2-1.7 8.5-2 9.7.4 1.2 2.3-2 6.4-5.3 8.1-3.2 1.7-5.2.3-6.4-2.1-1.2-2.3-1.2-4.7 2-6.4z"
              />
              <path
                fill="#E4F6FB"
                d="M653.4 455.5c3 2.1 5.7 6.6 4.1 8.7-1.5 2.2-6.7 1.2-9.7-.9s-2.6-4.5-1.1-6.6c1.5-2.1 3.7-3.2 6.7-1.2z"
              />
              <ellipse cx="656.2" cy="464.5" fill="#FEAF26" rx="3.9" ry="3.8" />
            </g>
            <g>
              <path
                fill="#E4F6FB"
                d="M698.4 548c-2.4 2.7-7.2 4.9-9.2 3.2s-.5-6.7 1.9-9.4 4.7-2.1 6.7-.4c2.1 1.6 3 3.9.6 6.6z"
              />
              <path
                fill="#E4F6FB"
                d="M697.8 558.8c-3.6-.5-8.1-3.2-7.7-5.8s5.4-4.1 9-3.6c3.6.5 4.4 2.7 4.1 5.3s-1.8 4.6-5.4 4.1z"
              />
              <path
                fill="#E4F6FB"
                d="M687.7 562.7c-1.3-3.4-1-8.6 1.5-9.5 2.5-.9 6.2 2.7 7.5 6.1s-.3 5.2-2.8 6.1c-2.5.9-4.9.7-6.2-2.7z"
              />
              <path
                fill="#E4F6FB"
                d="M680.6 552.2c3.2-1.7 8.5-2 9.7.4 1.2 2.3-2 6.4-5.3 8.1s-5.2.3-6.4-2.1c-1.2-2.4-1.2-4.8 2-6.4z"
              />
              <path
                fill="#E4F6FB"
                d="M687 543c3 2.1 5.7 6.6 4.1 8.7-1.5 2.2-6.7 1.2-9.7-.9s-2.6-4.5-1.1-6.6c1.6-2.2 3.7-3.3 6.7-1.2z"
              />
              <ellipse cx="689.8" cy="552" fill="#FEAF26" rx="3.9" ry="3.8" />
            </g>
            <g>
              <path
                fill="#68C902"
                d="M707.7 640.2c-10.2.1-19.8-.4-28.7-.7-4.4-.1-8.7-.2-13.1-.2-4.3 0-8.7.2-13 .3-17.3.8-34.6 3-51.6 6.6-2.7-.1-5.3-.2-8.1-.3 1.2-.6 2.3-1.2 3.5-1.8-.3-.4-.6-.5-.7-.2-.1-.4-1.1-2.9-1.3-4.7-.2-1.8-.2-3.1-.4-3.5.3.1.7.8.9 1.7-.2-1.3-.2-2.3-.1-3 .1-.7.1-2.2-.3-3.1.3-.2 1.8 2.8 2.5 7.5 0-1 .2-1.4.2-1.6v.2c-.1-2.9 0-4.9-.4-5.9.7.5 1.7 2.6 2 4.6-.3-3.1-.2-5.4.2-6.8.4-1.4.8-4.7-.2-7.1.6-.1 2.5 4.2 3.8 10.8.1-.5.3-.8.5-1 .4-.4 1.1-2 .6-4 .4.3 1.1 2.7 1.6 5.9.3-.8.6-1.4.8-2.3.9-3.6.7-4.9.3-8.4-.1-.8.3-1.1.5-.6.4.8.7 1.6 1 2.6.6.2 1.4 1.7 1.6 3.4-.3-2.7-.3-4.8 0-6.1.3-1.3.5-4.4-.3-6.3.7-.4 3.4 5.9 4.3 15.5 0-2.1.5-2.9.7-3.2 0 .1 0 .2.1.3.2-6 .5-10-.1-12.1 1.4 1.1 3.3 5.4 3.6 9.6-.2-6.3.3-11 1.4-13.7 1-2.7 2.4-9.3.7-14.5 1.4-.2 4.7 8.9 6.3 22.5.4-.9.8-1.6 1.2-1.9 1-.8 2.5-3.9 1.8-8 .8.6 1.9 5.6 2.3 12.3.7-1.6 1.5-2.8 2.1-4.6 2.6-7.3 2.5-9.9 2.1-17-.1-1.7.8-2.2 1.2-1.1 2.2 5.4 3 12.4 2.6 20.5-.2 3.9-.7 7.1-1.2 9.8.3 0 .6-.1 1-.1v-.1c.5-1.1 1-1.9 1.4-3.1 1.7-4.5 1.6-6.2 1.4-10.7 0-1.1.5-1.4.8-.7 1.3 3.4 1.8 7.8 1.4 12.9 0 .4-.1.7-.1 1.1l3.3-.3v-.9c.1-2.4.4-4 .2-4.7.3.2.8 1.2.8 2.3 0-1.7.2-3.1.5-3.9.3-.8.6-2.8.2-4.1.5-.2 1.7 4 1.6 10.2.2-1.3.5-1.8.7-2v.2c.5-3.8 1-6.4.7-7.8.8.8 1.7 3.7 1.6 6.4.3-4.1.9-7.1 1.8-8.7.8-1.7 2.1-5.9 1.3-9.3.9 0 2.4 6 2.6 14.9.3-.6.6-1 .9-1.2.7-.5 1.8-2.3 1.6-5 .5.5.9 3.7.7 8 .5-1 1.1-1.7 1.6-2.8 2.1-4.5 2.1-6.2 2.3-10.8 0-1.1.6-1.4.8-.7 1.1 3.6 1.3 8.1.5 13.3-.3 2.4-.8 4.4-1.2 6.1h.6c.4-.7.7-1.1 1.1-1.9 1.3-2.8 1.3-3.9 1.5-6.8 0-.7.4-.9.5-.4.6 2.3.7 5.1.3 8.4-.1.3-.1.6-.1.9 8.4.7 15.9 2.1 23.4 3.6 7.5 1.6 14.9 3.3 23 4.7-3.5 1.1-6.6 1.9-9.6 2.6zm-98.3-2.6c-.1-.4-.2-.9-.3-1.3 0 .8-.1 1.6-.2 2.3l.4-.2c0-.3.1-.6.1-.8z"
              />
            </g>
            <g>
              <path
                fill="#68C902"
                d="M667.4 641.7l-32.5-.4c-10.9-.1-20.3.2-27.7 1.9-1.2-.4-2.5-.7-3.8-1.1.4-.5.9-1 1.3-1.4-.2-.4-.4-.6-.4-.2-.1-.4-1-2.9-1.4-4.7-.4-1.8-.6-3-.8-3.4.2.1.5.8.7 1.7-.3-1.3-.5-2.3-.5-2.9 0-.6-.2-2.1-.6-3 .2-.2 1.4 2.9 2.4 7.5-.2-1-.1-1.4-.1-1.5v.2c-.4-2.9-.7-4.8-1-5.8.5.5 1.3 2.7 1.7 4.7-.5-3-.7-5.3-.6-6.6.1-1.3 0-4.5-.8-7 .4-.1 1.9 4.3 3.2 11 0-.4.1-.7.2-.9.2-.4.4-1.9 0-3.9.2.3.8 2.7 1.3 6 .1-.8.2-1.3.3-2.2.3-3.5.1-4.8-.3-8.3-.1-.8.1-1.1.3-.6.3.8.5 1.7.7 2.6.3.3.9 1.8 1.1 3.5-.3-2.6-.3-4.8-.2-6.1.1-1.3.2-4.3-.4-6.2.4-.4 2.2 6.1 2.9 15.7 0-2.1.2-2.8.3-3.1v.4c0-5.9.2-9.9-.3-12 .9 1.2 2 5.7 2.2 9.9-.2-6.3.2-10.9.9-13.5.7-2.6 1.6-9.1.7-14.3.9 0 2.8 9.3 3.4 23 .2-.9.5-1.5.8-1.8.6-.7 1.6-3.6 1.3-7.8.5.7 1 5.8 1 12.4.5-1.5.9-2.7 1.4-4.4 1.8-7 1.8-9.6 1.9-16.8 0-1.7.6-2.2.8-1.1 1.1 5.6 1.4 12.6.8 20.6-.3 3.8-.6 7-1 9.7l.6-.1v-.1c.3-1.1.7-1.8 1-3 1.1-4.4 1.2-6 1.2-10.5 0-1.1.3-1.4.5-.7.6 3.5.8 7.9.4 13 0 .4-.1.7-.1 1.1.6 0 1.3-.1 2-.1v-.9c.2-2.4.3-4 .3-4.6.2.2.4 1.2.4 2.4.1-1.7.2-3.1.4-3.9.2-.8.5-2.8.3-4 .3-.2.9 4.1.6 10.3.1-1.3.4-1.8.5-2v.2c.4-3.8.8-6.4.7-7.7.5.8.9 3.8.8 6.5.3-4 .7-7 1.3-8.6.5-1.6 1.3-5.8 1-9.2.5 0 1.3 6.1 1.2 15 .2-.6.4-.9.5-1.1.4-.5 1.1-2.3 1-5 .3.5.5 3.7.3 8.1.3-1 .7-1.7 1-2.8 1.3-4.5 1.3-6.2 1.5-10.8 0-1.1.4-1.4.5-.7.6 3.6.7 8.2.2 13.4-.2 2.4-.5 4.4-.8 6.1h.4c.2-.7.4-1.1.7-1.9.8-2.8.8-3.9.9-6.8 0-.7.2-.9.3-.4.4 2.3.4 5.1.1 8.4 0 .3-.1.6-.1.9 10.3 1.3 18.1 4.3 26.4 8.1-2 .3-3.6 1-5.2 1.6zm-57.1-6.1c-.1-.4-.2-.9-.2-1.3v2.2l.2-.1v-.8z"
              />
            </g>
            <g>
              <path
                fill="#68C902"
                d="M780.2 620.5c-12.5 6.7-25.6 11-38.5 13.7-12.9 2.7-25.7 4-38.1 4.5-12.4.5-24.4.2-35.9 0s-22.7-.4-33.4 0c-1.6-.3-3.2-.5-4.8-.8-1.6-.2-3.2-.5-4.8-.7 1.5-.4 3-.9 4.5-1.3-.3-.5-.6-.6-.8-.3-.1-.4-.7-3.1-.6-4.9.1-1.8.4-3.1.2-3.5.3.1.7.9.7 1.8 0-1.3.2-2.4.5-3 .3-.6.6-2.1.3-3.1.4-.2 1.6 3 1.4 7.8.2-1 .5-1.4.6-1.6v.2c.5-2.9 1-4.9.8-5.9.8.6 1.6 2.8 1.4 4.9.3-3.1 1-5.4 1.7-6.6.8-1.3 2-4.5 1.3-7 .8 0 2.1 4.6 2.2 11.3.3-.4.6-.7.8-.9.6-.4 1.7-1.8 1.6-3.8.4.3.8 2.8.6 6.1.5-.8 1-1.3 1.5-2.2 1.9-3.4 2-4.7 2.2-8.2 0-.8.6-1.1.8-.5.3.8.5 1.7.7 2.7.6.3 1.3 1.9 1.2 3.7.2-2.7.7-4.8 1.3-6 .6-1.3 1.6-4.3.9-6.2.9-.3 2.9 6.4 2 16 .5-2.1 1.2-2.7 1.6-3.1v.4c1.5-5.8 2.7-9.8 2.3-11.9 1.5 1.3 3 5.9 2.5 10.1 1-6.2 2.6-10.8 4.3-13.3 1.8-2.5 4.5-8.9 3.4-14.2 1.6 0 3.9 9.5 3.6 23.2.6-.8 1.2-1.4 1.8-1.7 1.4-.7 3.7-3.5 3.5-7.7.8.7 1.4 5.8.9 12.5 1.1-1.5 2.2-2.6 3.3-4.3 4.2-6.9 4.3-9.5 4.7-16.7.1-1.7 1.1-2.2 1.5-1 1.9 5.6 2.4 12.6.9 20.6-.7 3.8-1.6 7-2.6 9.7h1.3l.1-.1c.7-1.1 1.5-1.8 2.2-3 2.6-4.4 2.7-6 2.9-10.5 0-1.1.7-1.4 1-.7 1.3 3.5 1.6 7.9.7 13-.1.4-.1.7-.2 1.1 1.4 0 2.9-.1 4.4-.1 0-.3 0-.6.1-.9.3-2.4.7-4 .5-4.7.4.2.9 1.2.9 2.4.1-1.7.4-3.1.8-3.9.4-.8.9-2.8.5-4.1.6-.2 2 4 1.7 10.3.3-1.3.8-1.8 1-2v.2c.8-3.8 1.5-6.4 1.2-7.8 1 .8 2.1 3.7 2 6.4.4-4.1 1.3-7.1 2.3-8.8 1-1.7 2.4-6 1.4-9.3 1-.1 3 5.9 3.6 14.8.3-.6.7-1 1.1-1.2.9-.5 2.2-2.5 1.8-5.2.6.4 1.3 3.6 1.5 7.9.6-1 1.3-1.8 1.8-3 2.2-4.8 2-6.5 1.7-11.1-.1-1.1.6-1.5.9-.8 1.7 3.5 2.6 7.9 2.3 13.2-.1 2.4-.5 4.5-.9 6.2.3 0 .6 0 .9-.1.4-.7.8-1.2 1.2-2 1.4-3 1.2-4.1 1-7-.1-.7.4-.9.6-.5 1.2 2.1 1.8 4.9 1.6 8.2 0 .3 0 .6-.1.9 11.6-1.1 22-2.5 32.2-4.7 2.5-.5 5-1.2 7.6-1.8 1.3-.4 2.5-.7 3.7-1.1l1.9-.5 1.9-.6 3.7-1.2 3.7-1.4 1.9-.7 1.9-.8c1.2-.5 2.5-1.1 3.8-1.6-1.6 1.4-3.1 2.9-4.7 4.3-2.1.8-3.7 2.2-5.4 3.5zm-134 11c0-.4-.1-.9-.1-1.3-.2.8-.5 1.6-.8 2.2l.5-.1c.2-.3.3-.6.4-.8z"
              />
            </g>
            <g>
              <path
                fill="#68C902"
                d="M790.8 586.1c-4 4.3-8.1 8.8-12.7 13.3s-9.6 8.9-15.1 13.1c-5.6 4.2-11.7 8-18.4 11.2-6.7 3.1-14.1 5.7-22 7-1.2-.1-2.5-.3-3.7-.5-1.2-.2-2.4-.4-3.7-.7 1.1-.4 2.2-.9 3.3-1.3-.2-.4-.5-.6-.6-.3-.1-.4-.7-3.1-.7-4.9 0-1.8 0-3.1-.1-3.5.2.1.5.9.6 1.8-.1-1.3-.1-2.4 0-3 .1-.6.2-2.1-.1-3.1.2-.2 1.2 3 1.6 7.7 0-1 .2-1.4.2-1.6v.2c0-2.9 0-4.9-.3-5.9.5.6 1.3 2.7 1.5 4.7-.3-3.1-.2-5.4 0-6.7.2-1.3.2-4.5-.6-7 .4-.1 1.9 4.3 3.4 10.9.1-.4.2-.8.3-1 .3-.4.6-1.9 0-3.9.3.3 1.1 2.7 1.7 5.9.1-.8.3-1.4.4-2.3.2-3.6-.1-4.8-1-8.3-.2-.8 0-1.1.2-.6.4.8.7 1.6 1.1 2.5.4.2 1.2 1.7 1.7 3.3-.7-2.6-1-4.7-1.1-6-.1-1.3-.6-4.3-1.5-6.1.1-.2.9 1.2 2.1 3.8 1.1 2.6 2.6 6.4 4 11-.4-2-.3-2.8-.2-3.2 0 .1.1.2.1.3-1.2-5.8-2.1-9.7-3.1-11.6 1.1 1 3.5 4.9 4.8 8.9-1.9-6-2.9-10.5-3.3-13.1-.1-1.3-.6-3.5-1.4-6-.8-2.5-1.9-5.2-3.2-7.5.3-.1 1.6 1.9 3.6 5.4 2 3.5 4.8 8.6 7.8 14.8-.1-.9-.1-1.6 0-2 .3-.9-.1-4-2.2-7.6.7.5 3.4 4.8 6.3 10.7-.2-1.6-.3-2.9-.7-4.6-1.7-7-3.2-9.2-6.7-15.5-.9-1.5-.7-2.1 0-1.2 3.6 4.4 7.6 10.1 11.2 17.3 1.7 3.4 3 6.4 3.9 9l.6-.4v-.1c-.2-1.1-.2-2-.5-3.2-1.2-4.5-2.1-5.8-4.4-9.7-.6-.9-.4-1.3 0-.8 2.5 2.6 5.1 6.2 7.4 10.6.2.3.3.6.5 1 .6-.5 1.3-.9 1.9-1.4-.2-.3-.3-.5-.5-.8-1.2-2.1-2-3.5-2.4-4 .3 0 1.1.7 1.7 1.7-.9-1.4-1.6-2.7-1.9-3.4-.3-.8-1.2-2.5-2.1-3.5.1-.3 3.2 2.8 6.6 7.9-.7-1.2-.7-1.7-.7-1.9 0 .1.1.1.1.2-1.8-3.3-3.1-5.6-4-6.6.9.4 3.1 2.4 4.6 4.6-2.2-3.4-3.6-6.1-4.2-7.7-.6-1.6-2.6-5.4-5-7.8.4-.3 4.8 4 10.4 10.9-.2-.6-.3-1-.3-1.3.1-.7-.5-2.5-2.4-4.5.5.2 2.8 2.5 5.5 5.9-.4-1-.5-1.8-1-2.8-1.9-4.3-3-5.6-6-9.1-.7-.9-.7-1.3-.1-.8 2.9 2.3 6 5.6 9.1 9.8 1.4 1.9 2.5 3.6 3.4 5.1l.4-.3c-.3-.7-.4-1.2-.7-1.9-1.2-2.7-1.9-3.5-3.8-5.7-.5-.5-.4-.8 0-.5 1.8 1.4 3.8 3.4 5.8 6.1.2.3.4.5.5.7 4.7-3.5 9-6.4 13.2-8.9 4.2-2.5 8.4-4.7 12.7-6.7-.5 2.1-1.1 3.8-1.8 5.5zM729.1 622c-.1-.4-.3-.8-.4-1.3.1.8.1 1.6.1 2.2l.3-.2v-.7z"
              />
            </g>
            <g fill="#FFF">
              <path d="M589.8 661.6c-.2 0-.3-.1-.4-.2-.1-.1-.2-.2-.2-.3v-.4-.3-.7c0-.2.1-.5.1-.7 0-.1.1-.2.1-.3.1-.1.2-.1.3-.1h.2c.1 0 .2 0 .3.1.2 0 .4.1.6.1h.9c.3 0 .7 0 1-.1.3 0 .7-.1.9-.2.3-.1.5-.2.7-.3.2-.1.3-.3.3-.5s-.2-.3-.5-.4c-.3-.1-.8-.2-1.3-.3-.5-.1-1.1-.2-1.7-.4-.6-.1-1.2-.4-1.7-.6-.5-.3-.9-.6-1.3-1.1s-.5-1-.5-1.7.2-1.4.6-1.9c.4-.5.9-1 1.5-1.3.6-.3 1.3-.6 2.1-.8.8-.2 1.6-.2 2.4-.2h.6c.2 0 .4 0 .6.1l.1-.4c0-.1.1-.2.2-.3.1-.1.2-.1.3-.1.7 0 1.3.1 1.9.3.2.1.3.2.4.3.1.1.1.2.1.3 0 .4 0 .8-.1 1.2 0 .4-.1.7-.1 1 0 .3-.1.6-.1.9 0 .3-.1.6-.1.9 0 .2-.1.3-.2.4-.1.1-.3.2-.5.2h-.9c-.2 0-.5-.1-.8-.1-.1 0-.2-.1-.3-.2-.1-.1-.1-.3-.1-.4v-.4-.4c-.2 0-.5-.1-.7-.1h-.7c-.4 0-.7 0-1.1.1-.3 0-.6.1-.8.2l-.6.3c-.1.1-.2.3-.2.4 0 .2.2.4.5.5.3.1.7.2 1.2.3.5.1 1 .2 1.6.3.6.1 1.1.3 1.6.6s.9.6 1.2 1.1c.3.5.5 1.1.5 1.8s-.2 1.3-.5 1.8-.7 1-1.3 1.3c-.5.4-1.2.7-1.9.8-.7.2-1.5.3-2.4.3-.3-.2-1-.3-1.8-.4zM605.5 652.8c.2.1.3.1.4.2.1.1.1.2.1.4v.4c.9.2 1.7.7 2.2 1.4.5.7.8 1.5.8 2.5 0 .7-.1 1.3-.4 1.8-.3.5-.6 1-1.1 1.3-.5.4-1 .6-1.5.8-.6.2-1.1.3-1.7.3-.8 0-1.5-.1-2.1-.3-.6-.2-1.2-.5-1.6-.8-.4-.4-.8-.8-1-1.4-.2-.6-.4-1.2-.4-1.9s.1-1.4.4-2c.3-.6.7-1.1 1.2-1.5.5-.4 1-.7 1.6-1 .6-.2 1.2-.3 1.8-.3.2 0 .4 0 .7.1.2-.1.4 0 .6 0zm-.5 3.5c-.1 0-.3-.1-.3-.1-.1 0-.2-.1-.2-.2-.1-.1-.1-.2-.1-.3v-.4c-.6.1-1.1.3-1.5.7-.4.4-.6 1-.6 1.6 0 .3.1.5.2.7.1.2.2.4.4.5.2.1.4.3.6.3.2.1.5.1.7.1.2 0 .5 0 .7-.1.2-.1.5-.2.7-.3.2-.1.4-.3.5-.5.1-.2.2-.4.2-.7 0-.3-.1-.6-.3-.8-.4-.3-.7-.4-1-.5zM615.2 652.7c.3 0 .6 0 .9.1.3 0 .6.1.9.2.3.1.5.2.6.4.1.1.2.4.2.7 0 .2 0 .4.1.5v.5c0 .4 0 .8-.1 1.3 0 .2-.1.4-.2.5-.1.1-.3.1-.5.1-.4 0-.7 0-1-.1-.4-.1-.7-.4-.8-.8 0-.2 0-.3-.1-.5v-.5c-.3 0-.6.1-.9.2-.3.1-.5.3-.8.5-.2.2-.4.4-.5.7-.1.3-.2.5-.2.8 0 .3 0 .5.1.8.1.3.2.5.4.7.2.2.4.3.7.5s.5.2.9.2c.2 0 .3 0 .5-.1.2 0 .4-.1.5-.1.2-.1.3-.1.5-.2s.3-.1.4-.2c.1-.1.2-.1.3-.2.1 0 .2-.1.2-.1.2 0 .3.1.4.3.1.1.1.3.2.4.1.1.1.3.2.4 0 .1.1.2.1.3v.2c0 .2-.1.3-.3.5-.2.2-.4.3-.6.4s-.5.2-.8.3c-.3.1-.6.2-.9.2-.3.1-.6.1-.9.1-.8 0-1.4-.1-1.9-.2-.5-.2-1-.4-1.4-.6-.4-.3-.7-.5-.9-.9-.2-.3-.4-.7-.5-1-.1-.3-.2-.6-.2-.9 0-.3-.1-.6-.1-.8 0-.7.2-1.3.5-1.9.3-.6.7-1.1 1.2-1.5.5-.4 1.1-.7 1.8-1 .6-.1 1.3-.2 2-.2zM621.2 648.6c.3 0 .6 0 .8.1.2 0 .4.1.6.3.1.1.3.3.3.6.1.2.1.6.1.9 0 .2 0 .4-.1.6-.1.2-.1.4-.3.5-.1.1-.3.3-.6.3-.2.1-.6.1-.9.1-.3 0-.6 0-.8-.1-.2-.1-.4-.1-.5-.3-.1-.1-.2-.3-.3-.5-.1-.2-.1-.5-.1-.8 0-.6.1-1 .4-1.3.3-.2.8-.4 1.4-.4zm-1.5 5.4c0-.3 0-.5.1-.7.1-.2.2-.3.4-.3s.4-.1.7-.1H622.3c.2 0 .3.1.3.2s.1.3.1.6v3.6c0 1.1-.1 2.3-.2 3.5v.5c0 .1-.1.2-.1.3-.1.1-.2.1-.3.2s-.3.1-.5.1c-.3 0-.7 0-1-.1-.4 0-.6-.1-.7-.3-.1-.1-.2-.4-.2-.7 0-.4 0-.9-.1-1.3v-1.3-2c.1-.8.1-1.4.1-2.2zM631.1 661.7c-.3 0-.5-.1-.6-.3-.1-.1-.1-.3-.1-.6-.4.3-.8.5-1.3.7-.5.2-.9.3-1.4.3-.6 0-1.1-.1-1.5-.3-.5-.2-.8-.4-1.2-.8-.3-.3-.6-.7-.7-1.2-.2-.5-.3-.9-.3-1.5 0-.8.1-1.5.4-2.1.3-.7.7-1.2 1.2-1.7s1-.9 1.6-1.2c.6-.3 1.2-.4 1.9-.4.5 0 1.1.1 1.6.3 0-.2.1-.4.1-.5.1-.1.2-.1.4-.1s.5 0 .8.1c.3 0 .6.1.9.2.1 0 .3.1.4.1.1 0 .2.1.3.2.1.1.1.2.2.3v.5c0 1.1 0 2.2-.1 3.4-.1 1.2-.2 2.3-.3 3.4 0 .3-.1.6-.3.7s-.3.2-.7.3h-1.1c-.1 0-.2.2-.2.2zm-.6-3.4c0-.5 0-.9.1-1.4 0-.5 0-.9.1-1.4-.2-.1-.3-.1-.5-.2-.2 0-.4-.1-.6-.1-.4 0-.7.1-1 .2-.3.2-.5.4-.7.6-.2.2-.3.5-.4.8-.1.3-.2.5-.2.8 0 .5.1.8.4 1.1.3.3.7.4 1.2.4.3 0 .6-.1.9-.2.1-.1.4-.3.7-.6zM635.5 650.1c0-.4.1-.7.2-.8s.2-.2.4-.3c.3-.1.6-.1.9-.2.4 0 .7-.1.9-.1.2 0 .3 0 .4.1.1.1.1.3.1.6V653.7c0 .9 0 1.7-.1 2.6 0 .8-.1 1.6-.1 2.4 0 .7-.1 1.4-.1 1.9 0 .3-.1.6-.2.7-.1.2-.3.3-.7.3h-1c-.4 0-.6-.1-.7-.3-.1-.1-.2-.4-.2-.6 0-.5-.1-1.2-.1-2v-2.5c0-1 0-2.1.1-3.1 0-1.1.1-2.1.2-3zM645.8 661.6c-.2 0-.3-.1-.4-.2s-.2-.2-.2-.3v-.4-.3-.7c0-.2.1-.5.1-.7 0-.1.1-.2.1-.3.1-.1.2-.1.3-.1h.2c.1 0 .2 0 .3.1.2 0 .4.1.6.1h.9c.3 0 .7 0 1-.1.3 0 .7-.1.9-.2.3-.1.5-.2.7-.3.2-.1.2-.3.2-.5s-.2-.3-.5-.4c-.3-.1-.8-.2-1.3-.3-.5-.1-1.1-.2-1.7-.4-.6-.1-1.2-.4-1.7-.6-.5-.3-.9-.6-1.3-1.1s-.5-1-.5-1.7.2-1.4.6-1.9c.4-.5.9-1 1.5-1.3.6-.3 1.3-.6 2.1-.8.8-.2 1.6-.2 2.4-.2h.6c.2 0 .4 0 .6.1l.1-.4c0-.1.1-.2.2-.3.1-.1.2-.1.3-.1.7 0 1.3.1 1.9.3.2.1.3.2.4.3.1.1.1.2.1.3 0 .4 0 .8-.1 1.2 0 .4-.1.7-.1 1 0 .3-.1.6-.1.9 0 .3-.1.6-.1.9 0 .2-.1.3-.2.4-.1.1-.3.2-.5.2h-.9c-.2 0-.5-.1-.8-.1-.1 0-.2-.1-.3-.2-.1-.1-.1-.3-.1-.4v-.4-.4c-.2 0-.5-.1-.7-.1h-.7c-.4 0-.7 0-1.1.1-.3 0-.6.1-.8.2l-.6.3c-.1.1-.2.3-.2.4 0 .2.2.4.5.5.3.1.7.2 1.2.3.5.1 1 .2 1.6.3.6.1 1.1.3 1.6.6s.9.6 1.2 1.1c.3.5.5 1.1.5 1.8s-.2 1.3-.5 1.8-.7 1-1.3 1.3c-.5.4-1.2.7-1.9.8-.7.2-1.5.3-2.4.3-.2-.2-.9-.3-1.7-.4zM654.8 654.4v-.5c0-.1.1-.2.2-.3.1-.1.2-.1.3-.2.1 0 .3-.1.6-.1v-.5-.7-.7c0-.2 0-.4.1-.6.1-.2.2-.3.3-.4.2-.1.4-.2.7-.2.3 0 .7-.1 1.3-.1.3 0 .5.1.6.2.1.1.2.3.2.6v2.3c.2 0 .4 0 .6.1.2 0 .4 0 .6.1.2 0 .4.1.5.2.1.1.1.3.1.5v.5c0 .2 0 .4-.1.5 0 .2-.1.4-.3.5-.1.1-.3.1-.6.2-.2 0-.3 0-.5.1h-.4c0 .4 0 .8.1 1.4 0 .5.1 1 .1 1.5s.1.9.1 1.3v.8c0 .2 0 .4-.1.5-.1.1-.3.2-.5.2-.5.1-.9.1-1.4.1-.2 0-.4-.1-.5-.2s-.2-.3-.2-.6c-.1-.8-.2-1.7-.3-2.5-.1-.8-.1-1.7-.2-2.6l-.5-.1c-.2 0-.4-.1-.5-.2-.1-.1-.2-.3-.2-.5v-.4c-.1.1-.1-.1-.1-.2zM670.4 660.5c0 .3 0 .5-.1.7 0 .2-.2.3-.4.4-.3.1-.7.2-1 .3-.4.1-.7.1-1 .1-.4 0-.6-.2-.6-.6v-.2-.2c-.4.3-.9.5-1.4.7-.5.2-1 .2-1.5.2-.3 0-.5 0-.8-.1l-.9-.3c-.3-.2-.5-.4-.7-.8-.2-.3-.3-.8-.3-1.4v-1.1c0-.4 0-.9.1-1.4 0-.5.1-1 .1-1.5.1-.5.1-1.1.2-1.6 0-.3.2-.6.4-.7.2-.1.5-.2.9-.2h.6c.2 0 .4.1.6.1.2.1.3.2.4.3.1.1.1.3.1.5v.7c0 .3-.1.7-.1 1.1 0 .4-.1.8-.1 1.3v1.4c0 .3.1.5.2.7.1.2.3.3.5.3.3 0 .6-.1 1-.2.3-.1.7-.3 1-.5v-1.6c0-.5-.1-1-.1-1.4 0-.4-.1-.8-.1-1.1v-.6c0-.2.1-.4.2-.6.1-.1.4-.2.7-.3.1 0 .3-.1.5-.1h.5c.3 0 .6.1.8.2.2.1.3.3.3.6.1.9.2 1.8.2 2.8.1.9.1 1.9.1 2.9v.7c-.3 0-.3.3-.3.5zM678.5 661.7c-.2 0-.3-.1-.4-.1-.1 0-.2-.1-.2-.2s-.1-.2-.1-.3v-.4c-.8.7-1.7 1-2.6 1-.6 0-1.1-.1-1.6-.3-.5-.2-.9-.5-1.2-.9-.3-.4-.6-.8-.8-1.3-.2-.5-.3-1-.3-1.6 0-.7.1-1.4.4-2 .3-.6.6-1.1 1.1-1.6.5-.4 1-.8 1.6-1 .6-.2 1.2-.4 1.9-.4.3 0 .6 0 .9.1.3 0 .6.1.9.3v-1.8-1.4-.5c0-.1.1-.2.1-.3.1-.1.1-.1.2-.1s.2 0 .4-.1h1.6c.3 0 .5.1.6.2s.2.4.2.8v2.1c0 .9 0 1.8-.1 2.8 0 1-.1 2-.1 3-.1 1-.1 2-.2 2.9 0 .3-.1.6-.2.7-.1.1-.4.2-.7.3h-1.1c-.1 0-.2.1-.3.1zm-.4-6.3c-.2-.1-.3-.1-.5-.2-.2 0-.4-.1-.6-.1-.4 0-.7.1-1 .2-.3.1-.5.3-.7.5-.2.2-.3.5-.5.7-.1.3-.2.5-.2.8 0 .5.1.9.4 1.2.2.3.6.5 1.2.5s1.2-.3 1.8-.9l.1-2.7zM684.5 648.6c.3 0 .6 0 .8.1.2 0 .4.1.6.3s.3.3.3.6c.1.2.1.6.1.9 0 .2 0 .4-.1.6-.1.2-.1.4-.3.5-.1.1-.3.3-.6.3-.2.1-.6.1-.9.1-.3 0-.6 0-.8-.1-.2-.1-.4-.1-.5-.3-.1-.1-.2-.3-.3-.5-.1-.2-.1-.5-.1-.8 0-.6.1-1 .4-1.3.3-.2.7-.4 1.4-.4zM683 654c0-.3 0-.5.1-.7.1-.2.2-.3.4-.3s.4-.1.7-.1H685.6c.2 0 .3.1.3.2s.1.3.1.6v3.6c0 1.1-.1 2.3-.2 3.5v.5c0 .1-.1.2-.1.3-.1.1-.2.1-.3.2-.1 0-.3.1-.5.1-.3 0-.7 0-1-.1-.4 0-.6-.1-.7-.3-.1-.1-.2-.4-.2-.7 0-.4 0-.9-.1-1.3v-1.3-2c0-.8.1-1.4.1-2.2zM695.8 657.4c-.3.1-.7.2-1.1.3-.4.1-.9.2-1.4.2-.5.1-1 .1-1.5.2s-1 .1-1.5.1c.2.3.5.5.9.7.4.2.8.2 1.2.2.3 0 .7 0 1.1-.1.4-.1.8-.2 1.1-.4.2-.1.3-.1.4-.1.1 0 .2 0 .2.1s.1.2.1.3c0 .1.1.3.1.4 0 .1.1.3.1.4v.4c0 .2-.1.4-.3.6-.4.3-.9.6-1.5.8-.7.2-1.4.3-2.2.3-.6 0-1.1-.1-1.7-.3-.5-.2-1-.5-1.4-.9-.4-.4-.7-.9-1-1.4-.3-.5-.4-1.2-.4-1.8 0-.7.1-1.3.4-1.9.3-.6.6-1.1 1-1.5.4-.4.9-.7 1.5-1 .6-.2 1.2-.3 1.8-.3.8 0 1.5.1 2.1.4.6.3 1 .7 1.4 1.1.3.4.6.9.7 1.3.1.5.2.9.2 1.2 0 .1 0 .3-.1.4.1.2 0 .3-.2.3zm-3.9-2.2c-.4 0-.8.1-1.2.4-.4.3-.6.6-.7.9.5 0 1.1-.1 1.7-.1.6 0 1.1-.1 1.6-.2-.1-.3-.3-.6-.6-.7-.2-.3-.5-.3-.8-.3zM703.8 659.2c0 .4-.1.8-.3 1.1-.2.3-.5.6-.8.8-.4.2-.8.4-1.3.5s-1 .2-1.6.2c-.5 0-1 0-1.3-.1-.4-.1-.8-.2-1.1-.3-.3-.1-.5-.3-.5-.6 0-.1 0-.2.1-.4 0-.2.1-.3.2-.5s.2-.4.2-.5c.1-.2.2-.4.4-.4.1 0 .2 0 .5.1.2.1.5.2.7.2.2 0 .5.1.6.1.3 0 .5 0 .7-.1.2-.1.2-.2.2-.3 0-.1-.1-.2-.3-.4-.2-.1-.4-.2-.7-.3-.3-.1-.6-.2-.9-.4-.3-.1-.6-.3-.9-.6s-.5-.5-.7-.8c-.2-.3-.3-.7-.3-1.2 0-.4.1-.8.3-1.2.2-.4.5-.6.9-.9.4-.2.8-.4 1.3-.6.5-.1 1-.2 1.5-.2.4 0 .9 0 1.3.1s.9.2 1.2.3c.2.1.3.2.4.3.1.1.2.3.2.5s0 .5-.1.9c-.1.3-.1.6-.2.8-.1.2-.1.3-.2.4-.1.1-.3.2-.5.2-.4 0-.7 0-1.1-.1-.2 0-.4-.1-.5-.2-.1-.1-.1-.3-.1-.5v-.1c-.2-.1-.4-.1-.6-.1-.3 0-.6 0-.8.1-.2.1-.3.2-.3.4 0 .1.1.2.3.4.2.1.5.2.8.3.3.1.6.2 1 .4s.7.3 1 .6c.3.2.6.5.8.8.4.4.5.8.5 1.3z" />
            </g>
          </g>
          {resources && (
            <>
              <ResourceLink
                r={resources[0]}
                svgComponent={resource1SVGComponent}
                onElementHover={(e) =>
                  onElementHover(resources[0], e.target as SVGElement)
                }
                onElementLeave={() => onElementHover()}
                onElementClick={onClick}
              />
              <ResourceLink
                r={resources[1]}
                svgComponent={resource2SVGComponent}
                onElementHover={(e) =>
                  onElementHover(resources[1], e.target as SVGElement)
                }
                onElementLeave={() => onElementHover()}
                onElementClick={onClick}
              />
              <ResourceLink
                r={resources[2]}
                svgComponent={resource3SVGComponent}
                onElementHover={(e) =>
                  onElementHover(resources[2], e.target as SVGElement)
                }
                onElementLeave={() => onElementHover()}
                onElementClick={onClick}
              />
              <ResourceLink
                r={resources[3]}
                svgComponent={resource4SVGComponent}
                onElementHover={(e) =>
                  onElementHover(resources[3], e.target as SVGElement)
                }
                onElementLeave={() => onElementHover()}
                onElementClick={onClick}
              />
              <ResourceLink
                r={resources[4]}
                svgComponent={resource5SVGComponent}
                onElementHover={(e) =>
                  onElementHover(resources[4], e.target as SVGElement)
                }
                onElementLeave={() => onElementHover()}
                onElementClick={onClick}
              />
              <ResourceLink
                r={resources[5]}
                svgComponent={resource6SVGComponent}
                onElementHover={(e) =>
                  onElementHover(resources[5], e.target as SVGElement)
                }
                onElementLeave={() => onElementHover()}
                onElementClick={onClick}
              />
            </>
          )}
        </g>
      </g>
    </g>
  );
};
export default SocialStudiesLink;
